<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.project_name"
                  placeholder="请输入项目名称"
                  size="small"
                  :clearable="true"
                  style="width: 200px"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs.tables.handleSearch()"
                >搜索</el-button>
              </el-card>

              <WtDataTable ref="tables" :search="search" :listUrl="$db.config.publicBuildList">
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin:10px 0px"
                    icon="el-icon-plus"
                    type="primary"
                    @click="buildAdd(2)"
                  >自有项目申请</el-button>

                  <el-button
                    size="small"
                    icon="el-icon-plus"
                    type="primary"
                    @click="buildAdd(1)"
                  >合作项目申请</el-button>
                </div>
                <template slot="columns">
                  <!-- <el-table-column prop="project_code" label="立项编号" align="center" min-width="70"></el-table-column> -->
                  <el-table-column label="立项名称" prop="project_name" align="center" min-width="150">
                    <template slot-scope="scope">
                      <a
                        href="javascript:;"
                        @click="goDetail(scope.row.id)"
                      >{{scope.row.project_before_type == 2?scope.row.full_project_name:scope.row.project_name}}</a>
                      <!-- <router-link :to="'/hospitalBuildInfo/'+scope.row.id">{{scope.row.project_name}}</router-link> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="立项类型" align="center" width="150">
                    <template slot-scope="scope">
                      <span>{{scope.row.project_before_type_text}}</span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column prop="total_funds" label="预算金额" align="center" min-width="100"></el-table-column> -->
                  <el-table-column
                    prop="regdate_start"
                    label="立项开始时间"
                    align="center"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column prop="regdate_end" label="立项结束时间" align="center" min-width="100"></el-table-column>

                  <el-table-column label="审核状态" width="130" align="center">
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.province_audit_status == 2 && scope.row.if_province == 1"
                        style="color:red;text-decoration: underline; cursor: pointer;"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.province_audit_opinion"
                        >
                          <span slot="reference">{{scope.row.status_text}}</span>
                        </el-popover>
                      </span>

                      <span
                        v-else-if="scope.row.status == 3"
                        style="color:red;text-decoration: underline; cursor: pointer;"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.audit_opinion"
                        >
                          <span slot="reference">{{scope.row.status_text}}</span>
                        </el-popover>
                      </span>

                      <span
                        v-else-if="scope.row.stamp_status == 2 && scope.row.status == 5"
                        style="color:red;text-decoration: underline; cursor: pointer;"
                      >
                        <el-popover
                          placement="top"
                          title="协议说明："
                          width="200"
                          trigger="click"
                          :content="scope.row.remark"
                        >
                          <span slot="reference">{{scope.row.status_text}}</span>
                        </el-popover>
                      </span>

                      <span v-else>{{scope.row.status_text}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" min-width="150" fixed="right" align="center">
                    <template slot-scope="scope">
                      <el-button-group v-if="(scope.row.stamp_status == 2 || scope.row.stamp_status == 4) && scope.row.status == 5">
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          @click="getAuditInfoSealModal(scope.row.id,scope.row.agree_file_id_path)"
                        >协议盖章</el-button>

                        
                      </el-button-group>

                      <el-button-group v-else>
                        
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          :disabled="!scope.row.if_edit"
                          @click="publicEdit(scope.row.id,scope.row.project_before_type)"
                          size="mini"
                        >编辑</el-button>
                        <el-button
                          type="danger"
                          :disabled="!scope.row.if_edit"
                          icon="el-icon-delete"
                          @click="publicDel(scope.row.id)"
                          size="mini"
                        >删除</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>

              <el-dialog
                :visible="sealModelFlag"
                title="盖章提示"
                center
                width="30%"
                append-to-body
                @close="closeSealModal"
              >
                <el-form
                  :model="serlData"
                  ref="serlRef"
                  label-width="100px"
                  :rules="serlRules"
                  style="width:96%"
                >
                  <el-form-item label="盖章时间" prop="donor_agreement_time">
                    <el-date-picker
                      type="date"
                      placeholder="选择盖章日期"
                      value-format="yyyy-MM-dd"
                      v-model="serlData.donor_agreement_time"
                      style="width: 80%;"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="协议盖章：">
                    <el-upload
                      ref="sealUploads"
                      :action="uploadFileUrl"
                      :before-upload="beforeUpload"
                      :file-list="defFileArr"
                      :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defFileArr');
                    }"
                      :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defFileArr');
                    }"
                      :limit="1"
                    >
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                    <span>
                      <i class="el-icon-info"></i> 只能上传jpg/jpeg、png、pdf格式文件
                    </span>
                  </el-form-item>
                </el-form>
                <!-- <el-dialog :visible.sync="img_show" append-to-body>
                  <img width="100%" :src="img_url" alt />
                </el-dialog>-->
                <div style="margin-top: 10px" v-show="agFileLists[0]">
                  <span>
                    <i class="el-icon-info"></i>原协议附件：
                  </span>
                  <!-- <span
                    v-for="item in agFileLists"
                    :key="item.id"
                    style="text-decoration:underline;color:blue;cursor:pointer;margin-right:10px"
                    @click="downFile(item.id,item.name)"
                  >{{item.name}}</span>-->
                  <a
                    style="margin-right:8px;"
                    :href="item.url"
                    target="_blank"
                    v-for="(item,index) in agFileLists"
                    :key="index"
                  >{{item.name}}</a>
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="closeSealModal">取 消</el-button>
                  <el-button type="primary" @click="submitAg">确 定</el-button>
                </span>
              </el-dialog>

              <!-- <el-pagination
                style="margin-bottom: 20px;margin-right: 30px;float:right"
                background
                layout="prev, pager, next"
                :page-size="page_size"
                @current-change="changePage"
                :total="total"
              ></el-pagination>-->
            </div>
          </el-col>
        </el-row>
      </div>
      <detail v-if="if_open" v-model="if_open" :id="project_id"></detail>
      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import "../../public/poster.less";
import Axios from "axios";
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import detail from "./detail";

export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    detail
  },
  data() {
    return {
      search: {},
      project_id: null,
      if_open: false,

      tableData: [],
      page_size: 15,
      total: 0,
      agFileLists: [], //立项原协议数组
      defFileArr: [], //协议盖章

      sealModelFlag: false, //协议盖章modal
      uploadFileUrl: "",
      img_url: "", //图片预览路径
      img_show: false, //图片预览弹窗
      uploadParms: { file_type: 2 }, //图片上传所需参数
      serlData: { stamp_pics: [], donor_agreement_time: null, id: null }, //盖章信息
      serlRules: {
        donor_agreement_time: [
          { required: true, message: "请选择盖章时间！", trigger: "change" }
        ]
      }
    };
  },

  methods: {
    goDetail(id) {
      this.project_id = id;
      this.if_open = true;
    },
    // showImg(file) {
    //   //预览图片
    //   this.img_url = file.url;
    //   this.img_show = true;
    // },
    beforeUpload(file) {
      let bool = this.$fnc.checkUploadFile(file, ["jpg", "png", "jpeg", "pdf"]);
      return bool;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    downFile(id, name) {
      this.$db
        .downFilePost(this.$db.config.downloadFileUrl, { file_id: id })
        .then(res => {
          if (res.hasOwnProperty("code")) {
            var enc = new TextDecoder("utf-8");
            var result = JSON.parse(enc.decode(new Uint8Array(res)));
          } else {
            this.download(res, name);
          }
        });
    },
    // 下载文件
    download(data, name) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;

      alink.download = name; //文件名
      alink.click();
      this.downConfirm = false;
    },

    //提交协议
    submitAg() {
      let that = this;

      this.serlData.stamp_pics = [];
      let pic = that.defFileArr;

      if (pic && pic[0]) {
        for (const item of pic) {
          if (item.hasOwnProperty("response")) {
            this.serlData.stamp_pics.push(item.response.data.id);
          } else {
            this.serlData.stamp_pics.push(item.id);
          }
        }
      }

      this.$refs["serlRef"].validate(valid => {
        if (valid) {
          this.$db
            .post(this.$db.config.publicBuildSeal, this.serlData)
            .then(res => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.sealModelFlag = false;
                this.$refs.tables.handleSearch();
              }
            });
        } else {
          return this.$message.warning("请填写完整表单信息！");
        }
      });
    },

    //发起立项
    buildAdd(type) {
      this.$router.push({ name: "hospitalBuildInfo", query: { type: type } });
    },
    //编辑
    publicEdit(id, type) {
      this.$router.push({
        name: "hospitalBuildInfo",
        query: { id: id, type: type }
      });
    },

    //协议盖章弹框
    getAuditInfoSealModal(id, files) {
      this.serlData.id = id;
      this.agFileLists = files;
      this.sealModelFlag = true;
    },

    //弹框关闭调用
    closeSealModal() {
      this.serlData = {};
      this.$refs["sealUploads"].clearFiles();
      this.sealModelFlag = false;
    },

    //删除
    publicDel(id) {
      this.$confirm("确定删除这条立项信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$db
            .post(this.$db.config.publicBuildDel, { ids: id })
            .then(res => {
              if (res.code == 200) {
                this.$message.success("删除成功！");
                this.$refs.tables.reloadData();
              }
            });
        })
        .catch(() => {});
    }
  },
  mounted() {
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
  }
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/approval/list.vue